import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class Day {
  constructor(init) {
    // console.log('> Day constructor -', init)
    if (isNil(init)) return undefined

    // Valid inputs '...', { ... }
    // If it's a string, it's a full name, thus need to abbreviate it for display
    if (typeof init === 'string') {
      this._name = init
      this._display_name = init.substring(0, 3)
      this._enabled = true
    } else {
      this._name = init.name
      this._display_name = init.display_name
      this._enabled = init.enabled
    }
  }

  static shape = {
    name: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    enabled: PropTypes.bool
  }

  get name() {
    return this._name
  }

  get display_name() {
    return this._display_name
  }

  get enabled() {
    return this._enabled
  }

  // Calculable
  get getNameIfEnabled() {
    return this.enabled ? this.name : false
  }

  get getDisplayNameIfEnabled() {
    return this.enabled ? this.display_name : false
  }
}

export default Day
